module.exports = __webpack_public_path__ + "img/withoutImage.320e9d3d.jpg";